class ApiError extends Error {
  constructor(message, status, code, errors = [], data = null) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.errors = errors;
    this.data = data;
    this.type = "api";
  }
}

export const handleApiResponse = async (response) => {
  let data = null;

  try {
    data = await response.json();
  } catch (e) {
    // Fallback if JSON parsing fails
  }

  // 🔥 Global server status events
  // Note: Unreachable/Offline status is now primarily handled in requestHelper for structural failures.
  if (response.status < 500) {
    window.dispatchEvent(new CustomEvent("server-restored"));
  }

  // 🔥 Special business logic: Pending Approval
  if (response.status === 403 && data?.code === "PENDING_APPROVAL") {
    window.dispatchEvent(new CustomEvent("pending-approval-restriction"));
  }

  if (!response.ok) {
    const defaultMessage = response.status >= 500 
      ? "Internal Server Error. Please try again later." 
      : "An unexpected error occurred. Please try again later.";

    throw new ApiError(
      data?.message || defaultMessage,
      response.status,
      data?.code || "UNKNOWN_ERROR",
      data?.errors || [],
      data
    );
  }

  return data;
};